import {
	enableProdMode,
	ErrorHandler,
	importProvidersFrom,
	provideZoneChangeDetection,
} from "@angular/core"
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic"

import { environment } from "./environments/environment"
import {
	HTTP_INTERCEPTORS,
	provideHttpClient,
	withInterceptorsFromDi,
	withXsrfConfiguration,
	withXhr,
} from "@angular/common/http"
import { RegInterceptor } from "./app/services/reg.interceptor"
import { ErrorService } from "./app/services/error-service.service"
import { FullCalendarModule } from "@fullcalendar/angular"
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser"
import { AppRoutingModule } from "./app/app-routing.module"
import { FormsModule } from "@angular/forms"
import { NgxChartsModule } from "@swimlane/ngx-charts"
import { provideAnimations } from "@angular/platform-browser/animations"
import { AppComponent } from "./app/app.component"

if (environment.production) {
	enableProdMode()
}

bootstrapApplication(AppComponent, {
	providers: [
		provideZoneChangeDetection(),
		importProvidersFrom(
			FullCalendarModule,
			BrowserModule,
			AppRoutingModule,
			FormsModule,
			NgxChartsModule
		),
		{ provide: HTTP_INTERCEPTORS, useClass: RegInterceptor, multi: true },
		{ provide: ErrorHandler, useClass: ErrorService },
		provideHttpClient(withXhr(), withInterceptorsFromDi()),
		provideAnimations(),
	],
}).catch((err) => console.error(err))
